"use client";
import { useEffect, useState } from "react";
import { useMemoizedFn } from "ahooks";
import { useParams } from "next/navigation";
import { DeviceType } from "utils/src/uaDevicesParse/ua-device-parser";

export enum PC_SIZE_EUM {
  LARGE = "LARGE", // [1513, ∞)
  MEDIUM = "MEDIUM", // [880 ～ 1513)
  H5 = "H5", // (-∞, 880]
}

const getWindowSize = () => {
  let size = PC_SIZE_EUM.LARGE;
  if (window?.innerWidth < 964) {
    size = PC_SIZE_EUM.H5;
  } else if (window?.innerWidth < 1513) {
    size = PC_SIZE_EUM.MEDIUM;
  }
  return size;
};

export const useBaseUseIsPc = (): [
  boolean,
  <T = any>(data: T) => T,
  PC_SIZE_EUM | undefined,
] => {
  const { device } = useParams<{ device: DeviceType }>();
  const [windowSize, setWindowSize] = useState<PC_SIZE_EUM>(
    device === "desktop" ? PC_SIZE_EUM.LARGE : PC_SIZE_EUM.H5,
  );

  const isPC = windowSize !== PC_SIZE_EUM.H5;

  const handleWindowSizeChange = useMemoizedFn(() => {
    const curWindowSize = getWindowSize();

    setWindowSize(curWindowSize);
  });

  useEffect(() => {
    const windowSize = getWindowSize();
    setWindowSize(windowSize);
    window.addEventListener("resize", handleWindowSizeChange);

    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  // 根据是否是PC来决定是返回传入的数据还是undefined
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const getPCData = useMemoizedFn(<T = unknown>(data: T): T => {
    if (isPC) {
      return data;
    }
  });

  return [isPC, getPCData, windowSize];
};

export const useWindowSize = () => {
  const [isPC, getPCData, windowSize] = useBaseUseIsPc();

  return {
    isPC,
    getPCData,
    windowSize,
  };
};

export function useIsPc(): [boolean, <T = any>(data: T) => T] {
  const [isPC, getPCData] = useBaseUseIsPc();

  return [isPC, getPCData];
}
